import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
  })
  export class SnackBarService {
  
    // Temporarily stores data from dialogs
  
    durationTime = 1500;
  
    constructor(private snackBar: MatSnackBar,
      private translate: TranslateService,
      private zone: NgZone) { }
  
    showDeleteSuccess() {
      var displayMsg = "";
      this.translate.get('String_Success_Delete_Record').subscribe((res: string) => {
        displayMsg = res;
      });
  
      this.snackBar.open(displayMsg, "", {
        duration: this.durationTime,
      });
  
    }
  
  
    showAddSuccess() {
      var displayMsg = "";
      this.translate.get('String_Success_Add_Record').subscribe((res: string) => {
        displayMsg = res;
      });
  
      this.snackBar.open(displayMsg, "", {
        duration: this.durationTime,
      });
  
    }
  
  
  
    showUpdateSuccess() {
      var displayMsg = "";
      this.translate.get('String_Success_Update_Record').subscribe((res: string) => {
        displayMsg = res;
      });
  
      this.snackBar.open(displayMsg, "", {
        duration: this.durationTime,
      });
  
    }
  
    showFail() {
      var displayMsg = "Fail";
      // this.translate.get('String_Success_Update_Record').subscribe((res: string) => {
      //   displayMsg = res;
      // });
  
      this.snackBar.open(displayMsg, "", {
        duration: this.durationTime,
      });
    }
  
  
    showMsg(msgKey: string,vPosition,hPosition) {
      var displayMsg = msgKey;
  
      this.translate.get(msgKey).subscribe((res: string) => {
        displayMsg = res;
      });
  
      this.snackBar.open(displayMsg, "", {
        duration: this.durationTime,
        verticalPosition: vPosition,
        horizontalPosition: hPosition
      });
  
    }
    showMsgCenter(msgKey: string) {
      let displayMsg = msgKey;
      let panelClass = ['center-snackbar']; // Always use the custom class
  
      this.translate.get(msgKey).subscribe((res: string) => {
        displayMsg = res;
  
        this.snackBar.open(displayMsg, "", {
          duration: this.durationTime,
          panelClass: panelClass
        });
      });
    }
    
  }
  
  
  export class SnackBar_Config{
    public static VerticalPosition_TOP = "top";
    public static VerticalPosition_CENTER = "center";
    public static VerticalPosition_Bottom = "bottom";

    
    //'start' | 'center' | 'end' | 'left' | 'right'
    public static Horizontal_Start = "start";
    public static Horizontal_Center = "center";
    public static Horizontal_End = "end";
    public static Horizontal_Left = "left";
    public static Horizontal_Rihjt = "right";

  }
  
  
  